import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Card } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import {
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
} from "../../components/Component";
import { Table } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

const dataSourceMap: any = {
  "/view-all-sales-reports": {
    title: "Sales Reports",
    dataSource: [
      {
        key: "1",
        reportName: "Award from Customer",
        reportType: "Award from Customer",
        createdBy: "System Generated",
        onClickNavigation: "/award-from-customer-report",
      },
      {
        key: "2",
        reportName: "Sales By Customer",
        reportType: "Sales By Customer",
        createdBy: "System Generated",
        onClickNavigation: "/sales-by-customer-report",
      },
      {
        key: "3",
        reportName: "Sales By Material",
        reportType: "Sales By Material",
        createdBy: "System Generated",
        onClickNavigation: "/sales-by-material-report",
      },
      {
        key: "4",
        reportName: "Sales Report",
        reportType: "Sales Invoice Details",
        createdBy: "System Generated",
        onClickNavigation: "/invoice-for-customer-report",
      },
    ],
  },
  "/view-all-receivables-reports": {
    title: "Accounts Receivable Reports",
    dataSource: [
      {
        key: "1",
        reportName: "Customer Balances",
        reportType: "Customer Balances",
        createdBy: "System Generated",
        onClickNavigation: "/customer-balances-report",
      },
      {
        key: "2",
        reportName: "Receivables Aging Summary",
        reportType: "Receivables Aging Summary",
        createdBy: "System Generated",
        onClickNavigation: "/payment-aging-summary-reports-list",
      },
      {
        key: "3",
        reportName: "Payments Received By Customer",
        reportType: "Payments Received By Customer",
        createdBy: "System Generated",
        onClickNavigation: "/payments-received-by-customer-report",
      },
      {
        key: "4",
        reportName: "Delivery Note Details",
        reportType: "Delivery Note Details",
        createdBy: "System Generated",
        onClickNavigation: "/delivery-note-details-report",
      },
    ],
  },
};

function ViewAllReportsList() {
  const { data: allowedRoutes }: any = useSelector(
    (state: RootState) => state.allowedRoutes
  );
  const navigate = useNavigate();
  const [sm, setSm] = useState(false);
  const [screenSize, setScreenSize] = useState(0);
  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth >= 990) {
      setSm(false);
    }
  };
  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);
  const isActive = (path: string) => {
    return window.location.pathname === path ? "active" : "";
  };
  const LinkTo = ({ path }: any) => {
    if (!allowedRoutes.includes(path)) {
      return null;
    }
    path = "/" + path;
    switch (path) {
      case "/view-all-sales-reports":
        return (
          <li>
            <Link to={path} className={isActive(path)}>
              <span>Sales Reports</span>
            </Link>
          </li>
        );
      case "/view-all-receivables-reports":
        return (
          <li>
            <Link to={path} className={isActive(path)}>
              <span>Accounts Receivable Reports</span>
            </Link>
          </li>
        );
      default:
        return null;
    }
  };
  return (
    <>
      <Head title="View All Reports" />
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            <div
              className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg 
                ${sm ? "content-active" : ""}
              `}
            >
              <div className="card-inner-group">
                <div className="card-inner">
                  <div className="user-account-info py-0">
                    <h6 className="overline-title-alt" style={{ fontSize: 14 }}>
                      Modules
                    </h6>
                  </div>
                </div>
                <div className="card-inner p-0">
                  <ul className="link-list-menu">
                    {[
                      "view-all-sales-reports",
                      "view-all-receivables-reports",
                    ].map((item) => (
                      <li>
                        <LinkTo path={item} />
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            {/* content start here */}
            <div className="card-inner card-inner-lg">
              {sm && (
                <div
                  className="toggle-overlay"
                  onClick={() => setSm(!sm)}
                ></div>
              )}
              <BlockHead size="lg">
                <BlockBetween>
                  <BlockHeadContent>
                    <BlockTitle tag="h4">
                      <span>
                        {dataSourceMap[window.location.pathname].title}
                      </span>
                    </BlockTitle>
                  </BlockHeadContent>
                </BlockBetween>
              </BlockHead>
              <div className="content clearfix">
                <div
                  style={{
                    width: screenSize - 350 + "px",
                    margin: "0px auto",
                  }}
                >
                  <Table
                    className="customTable"
                    columns={[
                      {
                        title: "#",
                        key: "key",
                        width: 50,
                        render: (text, record, index) => index + 1,
                      },
                      {
                        title: "Report Name",
                        dataIndex: "reportName",
                        key: "reportName",
                        render: (text, record: any) => (
                          <span
                            className="inlineTableCellLink"
                            onClick={() => navigate(record?.onClickNavigation)}
                          >
                            {text}
                          </span>
                        ),
                      },
                      {
                        title: "Report Description",
                        dataIndex: "reportType",
                        key: "reportType",
                      },
                      // {
                      //   title: "Created By",
                      //   dataIndex: "createdBy",
                      //   key: "createdBy",
                      // },
                    ]}
                    dataSource={dataSourceMap[
                      window.location.pathname
                    ]?.dataSource?.filter((route: any) =>
                      allowedRoutes.includes(route?.onClickNavigation?.slice(1))
                    )}
                    locale={{
                      emptyText: (
                        <span
                          style={{
                            height: "300px",
                            color: "#333",
                            fontSize: "16px",
                          }}
                        >
                          Kindly contact the Admin to request access permission
                          for the{" "}
                          {dataSourceMap[window.location.pathname].title}.
                        </span>
                      ),
                    }}
                    bordered
                    size="middle"
                    pagination={false}
                  />
                </div>
              </div>
            </div>

            {/* content end here */}
          </div>
        </Card>
      </Content>
    </>
  );
}

export default ViewAllReportsList;
